import { ModulesMap, ModulesConfigMap } from '../modulesMaps'

export default {
	[ModulesConfigMap[ModulesMap.LOGISTIC_ROUTES].GET_LOGISTIC_ROUTES]: {
		url: '/company/:companyId/logistic_routes/',
	},

	[ModulesConfigMap[ModulesMap.LOGISTIC_ROUTES].GET_LOGISTIC_ROUTE]: {
		url: '/company/:companyId/logistic_routes/:logisticRouteId/',
	},

	[ModulesConfigMap[ModulesMap.LOGISTIC_ROUTES].GET_LOGISTIC_ROUTE_POPUP]: {
		url: '/company/:companyId/logistic_routes/:logisticRouteId/popup/',
	},

	[ModulesConfigMap[ModulesMap.LOGISTIC_ROUTES].GET_LOGISTIC_ROUTE_PREVIEW]: {
		url: '/company/:companyId/logistic_routes/:logisticRouteId/preview/',
	},

	[ModulesConfigMap[ModulesMap.LOGISTIC_ROUTES].CREATE_LOGISTIC_ROUTE]: {
		url: '/company/:companyId/logistic_routes/',
		requestOptions: {
			method: 'POST',
		},
	},

	[ModulesConfigMap[ModulesMap.LOGISTIC_ROUTES].PUT_LOGISTIC_ROUTE]: {
		url: '/company/:companyId/logistic_routes/:logisticRouteId/',
		requestOptions: {
			method: 'PUT',
		},
	},

	[ModulesConfigMap[ModulesMap.LOGISTIC_ROUTES].PATCH_LOGISTIC_ROUTE]: {
		url: '/company/:companyId/logistic_routes/:logisticRouteId/',
		requestOptions: {
			method: 'PATCH',
		},
	},

	[ModulesConfigMap[ModulesMap.LOGISTIC_ROUTES].DELETE_LOGISTIC_ROUTE]: {
		url: '/company/:companyId/logistic_routes/:logisticRouteId/',
		requestOptions: {
			method: 'DELETE',
		},
	},
}
